import { create } from "zustand";

type onOpenProps = {
  folderId: string;
};

type ModalStore = {
  folderId?: string;
  isOpen: boolean;
  onOpen: ({ folderId }: onOpenProps) => void;
  onClose: () => void;
};

const useAddStudySetsToFolderModal = create<ModalStore>((set) => ({
  isOpen: false,
  onOpen: ({ folderId }) =>
    set({
      isOpen: true,
      folderId,
    }),
  onClose: () => set({ isOpen: false }),
}));

export default useAddStudySetsToFolderModal;
